{
  "version": 1,
  "asset_id": "fe6832b2-27ab-4844-b6d0-2f7b022cd366",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/fe6832b2-27ab-4844-b6d0-2f7b022cd366/opt_assistido-4.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/fe6832b2-27ab-4844-b6d0-2f7b022cd366/opt_assistido-4.jpg",
  "original_filename": "opt_assistido-4.jpg",
  "size": 81641,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:33:03Z"
}
